/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */

export interface ReportVersionDto {
  /** Report ID */
  id: string;
  /** Version number */
  versionNumber: number;
  /** Is last version */
  isLastVersion: boolean;
  /** Version note */
  versionNote?: string;
  /** Created at */
  createdAt: string;
}
